import React from "react";
import MyAppBar from "../MyAppBar/MyAppBar.js";

export default function Dashboard() {
    return (
        < MyAppBar />
    );
}
